import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import Welcome from './welcome';

export default withLDConsumer()(Welcome);
